import "react-native-get-random-values";
import RnSodium from "react-native-sodium";
import { _setRnSodium } from "etebase";
_setRnSodium(RnSodium);
export * from "etebase";
//# sourceMappingURL=Etebase.js.map